import React from 'react'
import Button from '@jarvis.oddle/core/components/Button'
import Modal, {
  CloseButton,
  PrevButton
} from '@jarvis.oddle/core/components/Modal'
import { H4 } from '@jarvis.oddle/core/components/Typo'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'

import PromoCodePromotion from './PromoCodePromotion'
import NonPromoCodePromotion from './NonPromoCodePromotion'
import PromotionItemModal from './PromotionItemModal'
import CheckoutPromotionSummaryModal from './CheckoutPromotionSummaryModal'
import CheckoutFailedPromotionModal from './CheckoutFailedPromotionModal'
import ProceedToCheckoutButton from './ProceedToCheckoutButton'
import useAppSelector from 'src/hooks/useAppSelector'
import { selectOrder } from 'src/redux/order'
import { makeControlledModal } from 'src/decorators/ModalController'

const CheckoutPromotionModal = ({
  modal,
  goToPreviousModal,
  goToNextModal
}: {
  modal: {
    show: boolean
    onClose: () => void
    onClosed: () => void
  }
  goToPreviousModal: () => void
  goToNextModal: (modalName) => void
}) => {
  const { t } = React.useContext(TranslationContext)
  const { promoCodeEnabled, promotions } =
    useAppSelector(selectOrder).eligiblePromotions.data
  const selectedPromotions = useAppSelector(selectOrder).selectedPromotions

  return (
    <Modal {...modal} slideInAnimation='bottom'>
      <Modal.FlexContainer height={500}>
        <Modal.Header>
          <PrevButton onClick={goToPreviousModal} />
          <H4 normalised bold>
            {t('Promotions')}
          </H4>
          <CloseButton onClick={modal.onClose} />
        </Modal.Header>
        <Modal.Body>
          {promoCodeEnabled && (
            <Modal.Section>
              <PromoCodePromotion goToNextModal={goToNextModal} />
            </Modal.Section>
          )}
          {promotions && promotions.length > 0 && (
            <Modal.Section>
              <NonPromoCodePromotion
                promotions={promotions}
                goToNextModal={goToNextModal}
              />
            </Modal.Section>
          )}
        </Modal.Body>
        <Modal.Footer>
          {(selectedPromotions.data?.length || 0) > 0 ? (
            <Button
              fullWidth
              onClick={() => goToNextModal('CheckoutPromotionSummaryModal')}
            >
              {t('Next')}
            </Button>
          ) : (
            <ProceedToCheckoutButton
              text={t('Skip to checkout')}
              closeCurrentModal={modal.onClose}
              promotions={selectedPromotions.data}
            />
          )}
        </Modal.Footer>
      </Modal.FlexContainer>
    </Modal>
  )
}

const EnhancedCheckoutPromotionModal = makeControlledModal(
  CheckoutPromotionModal,
  'CheckoutPromotionModal'
) as unknown as React.FunctionComponent<Record<string, unknown>> & {
  PromotionItemModal
  SummaryModal
  CheckoutFailedPromotionModal
}

EnhancedCheckoutPromotionModal.PromotionItemModal = PromotionItemModal
EnhancedCheckoutPromotionModal.SummaryModal = CheckoutPromotionSummaryModal
EnhancedCheckoutPromotionModal.CheckoutFailedPromotionModal =
  CheckoutFailedPromotionModal

export default EnhancedCheckoutPromotionModal
